import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ContainerDefault from '../../components/ContainerDefault';
import { Loading } from '../../components/UtilComponent';
import * as pesagemAction from '../../services/pesagem/Action';
import * as Constants from '../../utils/constants';
import PrinterDetail from './components/PrinterDetail';
import Swal from 'sweetalert2';

class PrinterContainer extends Component {
    constructor() {
        super();
        this.handlePrintTermica = this.handlePrintTermica.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

    }

    componentDidMount() {
        this.props.action.getPesagemByIdAction(this.props.match.params.id);

    }

    handleCancel(event) {
        // event.preventDefault();
        this.props.history.replace(Constants.ROUTE_URL_PESAGENS);

    }
    handlePrintTermica() {
        Swal.fire({
            title: 'Realizar Impressão de nota não fiscal?',
            text: 'Informe a quantidade de cópias para impressão!',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, realizar impressão!',
            icon: "question",
            input: 'select',
            inputOptions: {
                '1': '1',
                '2': '2',
                '3': '3',
                '4': '4',
                '5': '5',
            },
            inputValue: '1',
            preConfirm: async (value) => {
                try {
                    if (!value) throw { 'detail': 'Informe pelo menos 1 cópia!' };
                    await this.props.action.setImpressaoTermica({ 'id': this.props.match.params.id, 'copia': value });
                    return 'ok'
                } catch (err) {
                    if (err) {
                        Swal.fire({
                            text: `${err['detail'] ? err['detail'] : ''}`,
                            icon: "error",
                        });
                    } else {
                        Swal.stopLoading();
                        Swal.close();
                    }

                    throw err;
                }
            },
            allowOutsideClick: () => !Swal.isLoading()

        }).then((result) => {
            if (result.value) {
                Swal.fire({
                    text: "Impressão realizada com sucesso!",
                    icon: "success",
                });
            } else {
                Swal.fire({
                    text: "Operação cancelada!",
                    icon: "info",
                });
            }
        }).catch(err => {
            if (err) {
                Swal.fire({
                    text: `Operação cancelada! ${err['detail'] ? err['detail'] : ''}`,
                    icon: "error",
                });
            } else {
                Swal.stopLoading();
                Swal.close();
            }
        });
    }
    

    retornarDadosTela() {
        const { pesagemObject, messages, messageSuccess, isLoading } = this.props;

        if (isLoading) return (
            <Loading title={Constants.DESCRICAO_PESAGEM} />
        );

        return (<ContainerDefault
            title={Constants.DESCRICAO_PESAGEM}
            messages={messages}
            messageSuccess={messageSuccess}
            container={
                <PrinterDetail
                    initialValues={pesagemObject}
                    handlePrintTermica={this.handlePrintTermica}
                    pesagemObject={pesagemObject}
                    handleCancel={this.handleCancel}
                    heading={'Imprimir'}
                />
            } />);

    }
    render() {
        return this.retornarDadosTela();
    }
}

const mapStateToProps = state => ({

    pesagemObject: state.pesagemReducer.pesagemObject,
    messages: state.messageResponseReducer.messages,
    messageSuccess: state.messageResponseReducer.messageSuccess,
    isLoading: state.apiReducer.isLoading,

})

const mapDispatchToProps = dispatch => ({

    action: bindActionCreators(pesagemAction, dispatch)

});

export default connect(mapStateToProps, mapDispatchToProps)(PrinterContainer);